var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3526 0.462281C48.8697 1.7235 61.237 16.1356 59.9757 32.6527C58.7145 49.1698 44.3024 61.5371 27.7853 60.2758C11.2683 59.0146 -1.09904 44.6025 0.162186 28.0854C1.42341 11.5684 15.8356 -0.798942 32.3526 0.462281ZM28.192 54.9496C41.7675 55.9862 53.6129 45.8214 54.6495 32.246C55.6861 18.6706 45.5213 6.82514 31.9459 5.78854C18.3705 4.75193 6.52505 14.9167 5.48844 28.4921C4.45184 42.0676 14.6166 53.913 28.192 54.9496Z",
    fill: "#7EE5DF",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90254 32.9853C1.43588 33.1428 0.362501 34.463 0.649727 35.9098C1.42516 39.816 2.97268 43.5379 5.21108 46.8532C7.94886 50.9081 11.637 54.2318 15.954 56.5343C20.271 58.8369 25.0858 60.0484 29.9784 60.0633C34.871 60.0781 39.693 58.8959 44.0239 56.6196C48.3548 54.3433 52.0631 51.0421 54.8255 47.0038C57.5879 42.9656 59.3204 38.3129 59.8721 33.4514C60.4237 28.59 59.7777 23.6673 57.9904 19.1128C56.5292 15.3891 54.3413 12.0038 51.5637 9.14993C50.5348 8.09285 48.8387 8.22824 47.8773 9.34699C46.9159 10.4657 47.0559 12.1429 48.0641 13.2197C50.1914 15.4915 51.875 18.1519 53.0179 21.0642C54.4868 24.8075 55.0178 28.8535 54.5644 32.8491C54.1109 36.8448 52.687 40.6689 50.4166 43.9879C48.1462 47.307 45.0983 50.0203 41.5387 51.8911C37.9791 53.762 34.0159 54.7337 29.9946 54.7215C25.9733 54.7093 22.0161 53.7136 18.4679 51.8211C14.9198 49.9286 11.8884 47.1969 9.63824 43.8641C7.88765 41.2713 6.65118 38.3759 5.98636 35.3354C5.67127 33.8943 4.36921 32.8279 2.90254 32.9853Z",
    fill: "url(#paint0_linear_0_1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3238 38.1064L32.1287 27.9113L20.2174 16H19.2865L19.0965 16.483C18.5948 17.7578 18.3804 19.0617 18.4767 20.2534C18.5864 21.6119 19.1025 22.7881 19.9692 23.6549L29.2678 32.9534L30.4943 31.727L39.0908 41.3395C39.9459 42.1946 41.4178 42.2454 42.3238 41.3395C43.2152 40.4481 43.2152 38.9978 42.3238 38.1064Z",
    fill: "#62EAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9589 30.7998L17.6763 38.0824C16.785 38.9737 16.785 40.4241 17.6763 41.3154C18.523 42.1621 19.9878 42.2369 20.9093 41.3154L28.1919 34.0327L24.9589 30.7998Z",
    fill: "#62EAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8956 20.329L37.7645 24.4601L36.6868 23.3824L40.8179 19.2513L39.7402 18.1736L35.6092 22.3047L34.5315 21.227L38.6626 17.0959L37.585 16.0183L32.1966 21.4067C31.5374 22.0659 31.1438 22.9412 31.0881 23.8714C31.074 24.1071 31.0206 24.3389 30.932 24.5594L34.4323 28.0597C34.6528 27.9709 34.8847 27.9176 35.1203 27.9035C36.0505 27.848 36.9258 27.4543 37.585 26.7951L42.9734 21.4068L41.8956 20.329Z",
    fill: "#62EAE1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 3.74705,
    y1: 37.1857,
    x2: 42.1588,
    y2: 2.50833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EAE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EE5DF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.c322b8c50dd9144368ad8a78b9bbe34a.svg";
export { ForwardRef as ReactComponent };